import { put, call, debounce } from 'redux-saga/effects';
import ActionTypes from '../../../../Data/ActionTypes';
import getPlacePredictionsQuery from './getPlacePredictionsQuery';

const DEBOUNCE_TIMEOUT = 400;

/**
 * getPlacePredictions
 *
 * This saga is used to fetch place predictions from the Google Places API and store them against the relevant component.
 *
 * @param {Object} action
 * @param {Object} action.payload
 * @param {string} action.payload.input
 * @param {string} action.payload.visitorId
 * @param {string} action.payload.regionCode
 * @param {number} action.payload.componentId
 * @param {string} action.payload.locationBias
 */
export function* getPlacePredictions(action) {
  const { input, visitorId, regionCode, componentId, locationBias } =
    action.payload;

  if (!input || !visitorId) {
    return;
  }

  try {
    const requestArguments = {
      input,
      visitorId,
      regionCode,
      locationBias,
    };

    const args = {
      variables: requestArguments,
    };

    const placePredictions = yield call(getPlacePredictionsQuery, args);

    yield put({
      type: 'COMPONENTS/setOptions',
      payload: {
        options: placePredictions,
        componentId,
      },
    });
  } catch (error) {
    // TODO: possibly push these errors to Sentry or datadog so we can track them
  }
}

/**
 * Redux Watcher
 */
export default function* getPlacePredictionsWatcher() {
  yield debounce(
    DEBOUNCE_TIMEOUT,
    ActionTypes.GET_PLACE_PREDICTIONS,
    getPlacePredictions
  );
}
